import { post } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getTransactionProvisionSettleList = (record) => post(url.GET_TRANSACTION_PROVISION_SETTLE_LIST, record)
export const getTransactionProvisionSettleSearch = (record) => post(url.GET_TRANSACTION_PROVISION_SETTLE_SEARCH, record);
export const getTransactionProvisionSettleLinkedAmount = (record) => post(url.GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS, record);
